<script setup>
	import {
		fetchCompareVersion
	} from "@/api/commonApi";
	import {
		layer
	} from "vue3-layer";
	import {
		ref
	} from "vue";

	const showOpenBrowserMask = ref(false)

	const isWeChatBrowser = () => {
		// 微信内置浏览器的 User-Agent 中包含 'MicroMessenger' 字符串
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /MicroMessenger/i.test(userAgent);
	}


	const downloadApp = () => {
		if (isWeChatBrowser()) {
			document.body.style.overflow = 'hidden'
			showOpenBrowserMask.value = true
			return
		}
		fetchCompareVersion('100').then(res => {
			if (res.code === 0) {
				location.href = res.data.apk_file_url;
			}
		})
	}


	const forbid = () => {
		layer.msg("暂未开放");
	}
</script>

<template>
	<div class="page">
		<div class="banner">
			<div class="banner-bg"></div>
			<div class="header">
				<img src="@/assets/image/logo.png" alt="" class="logo">
			</div>
			<img src="@/assets/image/banner.png" class="banner-image" alt="">
			<img src="@/assets/image/mobile-banner.png" class="mobile-banner-image" alt="">
			<img src="@/assets/image/icon-tree.png" class="icon-tree" alt="">
			<img src="@/assets/image/icon-cloud.png" class="icon-cloud-1" alt="">
			<img src="@/assets/image/icon-cloud.png" class="icon-cloud-2" alt="">
		</div>
		<div class="section section-1">
			<img src="@/assets/image/icon-screenshot-1.png" class="cover" alt="">
			<div class="section-text">
				<p class="title">4种跳绳模式</p>
				<p class="sub-title">自由切换</p>
				<p class="description">“定时，定数，定速，自由”，随时随地畅享运动自由!</p>
			</div>
			<img src="@/assets/image/icon-jump-rope.png" class="icon-jump-rope" alt="">
		</div>

		<div class="section section-2">
			<img src="@/assets/image/jump-rope-text.png" class="jump-rope-text" alt="">
			<div class="section-text">
				<p class="title">每日跳绳</p>
				<p class="sub-title">作业打卡</p>
				<p class="description">老师一键布置作业<br>学生轻松提交成果，跳绳学习超省心!</p>
			</div>
			<img src="@/assets/image/icon-screenshot-2.png" class="cover" alt="">
		</div>

		<div class="section section-3">
			<div class="left">
				<img src="@/assets/image/pk_pic.png" class="cover mobile" alt="">
				<img src="@/assets/image/rank_pic.png" class="cover mobile" alt="">
			</div>
			<div class="right">
				<div class="pk-text">
					<span>一分钟</span>
					<img src="@/assets/image/pk_text.png" alt="">
					<span>赛</span>
				</div>
				<p class="description">两人欢乐对跳，多人组队PK，同校、同城、同省<br />乃至全国:寻找你的跳绳搭子!</p>
			</div>
		</div>

		<div class="section section-4">
			<div class="section-text">
				<p class="title">每月</p>
				<p class="sub-title">跳绳挑战赛</p>
				<p class="description">每月<span style="color: #FF9000;font-size: 0.4rem;font-style: italic;font-weight:600">1-7日</span>报名，历经训练期、冲刺期、决战期，<br/>月底决出胜负，赢取精美礼品!</p>
			</div>
			<div class="right">
				<img src="@/assets/image/changle_pic.png" class="mobile" alt="">
				<img src="@/assets/image/game_pic.png" class="mobile" alt="">
			</div>
		</div>

		<div class="section section-5">
			<p class="title">花样跳绳</p>
			<p class="sub-title">课程视频</p>
			<p class="description">课程视频 魔法盒子，装满新奇玩法，学跳绳超带感!</p>
			<img src="@/assets/image/icon-person.png" alt="" class="icon-person">
		</div>

		<div class="footer">
			<img src="@/assets/image/logo-white.png" alt="" class="logo">
			<div class="download-group">
				<img src="@/assets/image/icon-ios.png" @click="forbid" alt="" class="download">
				<img src="@/assets/image/icon-android.png" @click="downloadApp" alt="" class="download">
			</div>
			<div class="mobile-download-group">
				<p class="text">更多功能，尽在U趣跳绳APP</p>
				<button class="button" @click="downloadApp">下载APP</button>
			</div>
			<p class="copyright">联系电话:(0532)87222535<br>公司地址:山东省青岛市胶州市兰州西路819号<br>&copy;2025 uqjump.com
				胶州市优趣部落儿童课外实践活动中心 版权所有<br>备案号:鲁ICP备2025141874号</p>
			<div class="mobile-footer-bottom">
				<img src="@/assets/image/logo.png" alt="" class="logo" />
				<button class="button" @click="downloadApp">立即下载</button>
			</div>
		</div>

	</div>

	<div class="mask open-browser-mask" v-show="showOpenBrowserMask">
		<img src="@/assets/image/open-browser-tip.png" class="image">
	</div>

</template>

<style scoped lang="scss">
	.page {
		width: 100%;

		.banner {
			width: 100%;
			height: 8.12rem;
			overflow: hidden;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-direction: column;

			.banner-bg {
				width: 165%;
				height: 200%;
				background: #DDF3FF;
				border-radius: 50%;
				position: absolute;
				left: 50%;
				top: 0;
				transform: translate(-50%, -50%);
				z-index: 0;
			}

			.header {
				width: 12.1rem;
				position: relative;
				z-index: 1;
				display: flex;
				align-items: center;
				justify-content: flex-start;

				.logo {
					width: 1.94rem;
					vertical-align: middle;
					margin-top: 0.39rem;
				}
			}

			.banner-image {
				width: 12.1rem;
				position: relative;
				z-index: 1;
				margin: 0;
				vertical-align: middle;
			}

			.mobile-banner-image {
				display: none;
			}

			.icon-tree {
				width: 1.32rem;
				position: absolute;
				left: 1.52rem;
				bottom: 0.92rem;
			}

			.icon-cloud-1 {
				width: 2.41rem;
				position: absolute;
				top: 0.85rem;
				right: 0.83rem;
			}

			.icon-cloud-2 {
				width: 1.51rem;
				position: absolute;
				top: 3.06rem;
				left: 2.19rem;
				z-index: 1;
			}
		}

		.section {
			width: 100%;
			padding: 0.8rem 0;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			&.section-1 {
				.cover {
					width: 5.75rem;
				}

				.section-text {
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					justify-content: center;
					margin-left: 0.1rem;

					.title {
						font-weight: 800;
						font-size: 0.9rem;
						color: #FF933E;
						margin: 0;
					}

					.sub-title {
						font-size: 0.6rem;
						color: #000;
						margin: 0;
					}

					.description {
						font-weight: 400;
						font-size: 0.3rem;
						color: #000000;
						line-height: 0.48rem;
						opacity: 0.8;
						margin-top: 0.5rem;
					}
				}

				.icon-jump-rope {
					position: absolute;
					width: 1.58rem;
					bottom: 0;
					right: 0.8rem;
				}
			}

			&.section-2 {
				.jump-rope-text {
					position: absolute;
					width: 14.87rem;
					left: 50%;
					transform: translateX(-50%);
					top: 0.8rem;
					z-index: -1;
				}

				.cover {
					width: 5.75rem;
					margin-left: 1.32rem;
				}

				.section-text {
					.title {
						font-weight: bold;
						font-size: 0.6rem;
						color: #257AFF;
						margin: 0;
					}

					.sub-title {
						font-weight: bold;
						font-size: 0.92rem;
						color: #333333;
						margin: 0;
					}

					.description {
						font-weight: 400;
						font-size: 0.3rem;
						color: #000000;
						margin: 0;
						margin-top: 0.65rem;
						opacity: 0.8;
					}
				}
			}

			&.section-3 {
				display: flex;
				background: url(@/assets/image/pk_bg.png) no-repeat center;
				background-size: auto 7rem;
				gap: 1rem;
				.left {
					height: 100%;
					display: flex;
					align-items: center;
					gap: 0.4rem;
					.mobile {
						height: 5.5rem;
					}
				}
				.right {
					width: 6rem;
					.pk-text {
						display: flex;
						align-items: end;
						margin-left: 1rem;
						span {
							font-weight: 800;
							font-size: 0.6rem;
							line-height: 1.7;
						}
						img {
							width: 1.4rem;
							object-fit: contain;
						}
					}

					.description {
						font-size: 0.25rem;
						margin-top: 0.6rem;
						text-align: right;
					}
				}
			}

			&.section-4 {
				.cover {
					width: 5.75rem;
					margin-left: 1.32rem;
				}

				.section-text {
					.title {
						font-weight: bold;
						font-size: 0.6rem;
						color: #3B3B3B;
						margin: 0;
					}

					.sub-title {
						font-weight: bold;
						font-size: 0.92rem;
						color: #FE702B;
						margin: 0;
					}

					.description {
						font-weight: 400;
						font-size: 0.3rem;
						color: #000000;
						margin: 0;
						margin-top: 0.65rem;
						opacity: 0.8;
					}
				}

				.right {
					display: flex;
					align-items: center;
					gap: 0.4rem;
					.mobile {
						height: 5.5rem;
						object-fit: cover;
					}
				}
			}

			&.section-5 {
				width: 15.56rem;
				padding: 0;
				background: url(@/assets/image/border-image.png) no-repeat center 0.23rem/100% auto;
				flex-direction: column;
				margin: 0 auto;
				transform: translateY(0.72rem);

				.title {
					font-weight: bold;
					font-size: 0.6rem;
					color: #AB81FB;
					margin: 0;
					margin-top: 1.81rem;
				}

				.sub-title {
					font-weight: bold;
					font-size: 1rem;
					color: #000000;
					margin: 0;
					margin-top: 0.31rem;
				}

				.description {
					font-size: 0.3rem;
					color: #000000;
					margin: 0;
					margin-top: 0.5rem;
				}

				.icon-person {
					width: 11.33rem;
					margin-top: 0.8rem;
					vertical-align: middle;
				}
			}
		}

		.footer {
			width: 100%;
			height: 6rem;
			background: #2D2F33;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.logo {
				width: 1.94rem;
				vertical-align: middle;
				margin-top: 1.15rem;
			}

			.download-group {
				width: 15.74rem;
				padding-top: 0.56rem;
				padding-bottom: 1.11rem;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 0.13rem;

				.download {
					width: 1.53rem;
					cursor: pointer;
				}

				border-bottom: 1px solid rgba(255, 255, 255, 0.15);
			}

			.copyright {
				font-weight: 400;
				font-size: 0.14rem;
				color: #FFFFFF;
				text-align: center;
				margin-top: 0.6rem;
				line-height: 0.24rem;
			}

			.mobile-download-group,
			.mobile-footer-bottom {
				display: none;
			}
		}
	}

	@media screen and (max-width: 1350px) {
		.page {
			width: 100%;

			.banner {
				width: 100%;
				height: auto;
				padding-bottom: 0.41rem;

				.header {
					width: calc(100% - 0.35rem * 2);
					padding: 0.43rem 0 0.23rem;
					margin: 0 auto;

					.logo {
						width: 1.94rem;
						margin: 0;
					}
				}

				.banner-image {
					display: none;
				}

				.mobile-banner-image {
					display: block;
					width: calc(100% - 0.35rem * 2);
					position: relative;
					z-index: 1;
				}

				.icon-tree {
					display: none;
				}

				.icon-cloud-1 {
					width: 0.74rem;
					left: 0;
					top: 45%;
					z-index: 1;
				}

				.icon-cloud-2 {
					width: 1.04rem;
					left: unset;
					right: -0.1rem;
					top: 1rem;
				}
			}

			.section {
				&.section-1 {
					flex-direction: column-reverse;
					padding: 0.7rem 0;

					.cover {
						width: calc(100% - 0.87rem * 2);
					}

					.icon-jump-rope {
						display: none;
					}

					.section-text {
						width: 100%;
						margin: 0;
						align-items: center;

						.title {
							font-size: 0.48rem;
						}

						.sub-title {
							font-size: 0.72rem;
						}

						.description {
							font-size: 0.24rem;
						}
					}
				}

				&.section-2 {
					flex-direction: column;
					padding-top: 0.77rem;
					padding-bottom: 0.6rem;

					.cover {
						width: calc(100% - 0.88rem * 2);
						margin: 0;
						margin-top: 0.6rem;
					}

					.jump-rope-text {
						width: 100%;
						top: 0;
					}

					.section-text {
						align-items: center;

						.title {
							text-align: center;
							font-size: 0.46rem;
						}

						.sub-title {
							font-size: 0.72rem;
							margin-top: 0.06rem;
							text-align: center;
						}

						.description {
							text-align: center;
							margin-top: 0.36rem;
							font-size: 0.17rem;
						}
					}
				}

				&.section-3 {
					flex-direction: column;
					padding-top: 0.77rem;
					padding-bottom: 0.6rem;
					gap: 0;
					background-size: auto 9rem;
					.right {
						.pk-text {
							margin-top: 0.3rem;
						}
						.description {
							margin-top: 0;
							text-align: center;
						}
					}
				}

				&.section-4 {
					flex-direction: column;
					padding-top: 0.77rem;
					padding-bottom: 0.6rem;

					.right {
						margin-top: 0.6rem;
					}

					.jump-rope-text {
						width: 100%;
						top: 0;
					}

					.section-text {
						align-items: center;

						.title {
							text-align: center;
							font-size: 0.46rem;
						}

						.sub-title {
							font-size: 0.72rem;
							margin-top: 0.06rem;
							text-align: center;
						}

						.description {
							text-align: center;
							margin-top: 0.36rem;
							font-size: 0.17rem;
						}
					}
				}

				&.section-5 {
					width: 100%;
					transform: none;
					background-position-y: 0;
					background-size: 150%;

					.icon-person {
						width: 100%;
						margin-top: 0.66rem;
					}

					.title {
						margin-top: 1.4rem;
						font-size: 0.47rem;
					}

					.sub-title {
						margin-top: 0.17rem;
						font-size: 0.78rem;
					}

					.description {
						font-size: 0.24rem;
						margin-top: 0.4rem;
					}
				}
			}

			.footer {
				width: 100%;
				height: auto;
				background: none;

				.download-group {
					display: none;
				}

				.logo {
					display: none;
				}

				.mobile-download-group {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					margin-top: 0.74rem;

					.text {
						font-weight: 400;
						font-size: 0.26rem;
						color: #000000;
					}

					.button {
						width: 2.06rem;
						height: 0.92rem;
						box-sizing: border-box;
						background: #FF762B;
						border-radius: 0.46rem;
						font-weight: 400;
						font-size: 0.36rem;
						color: #FFFFFF;
						border: none;
						white-space: nowrap;
					}
				}

				.copyright {
					margin-top: 0.78rem;
					margin-bottom: 0;
					font-weight: 300;
					font-size: 0.14rem;
					color: #999999;
					line-height: 0.24rem;
					text-align: left;
					width: 100%;
					box-sizing: border-box;
					padding-left: 0.36rem;
				}

				.mobile-footer-bottom {
					width: 100%;
					height: 1.38rem;
					background: #FAFAFA;
					display: flex;
					align-items: center;
					justify-content: space-between;
					box-sizing: border-box;
					padding: 0 0.36rem;
					margin-top: 0.3rem;

					.logo {
						display: block;
						margin: 0;
						width: 2.2rem;
					}

					.button {
						width: 1.96rem;
						height: 0.78rem;
						background: #FF762B;
						border-radius: 0.39rem;
						font-weight: 400;
						font-size: 0.30rem;
						color: #FFFFFF;
						border: none;
						white-space: nowrap;
					}
				}
			}
		}
	}

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, 0.78);
		z-index: 999;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		&.open-browser-mask {
			.image {
				position: absolute !important;
				right: 0;
				top: 0;
				width: 87%;
			}
		}

	}
</style>